/**
 * Класс для управления условным селектом с дополнительным полем ввода.
 * Обрабатывает логику отображения/скрытия дополнительного поля при выборе определенного значения.
 *
 * @class ConditionalSelect
 */
export class ConditionalSelect {
  /**
   * Создает экземпляр ConditionalSelect.
   *
   * @param {HTMLElement} container - Родительский контейнер селекта
   */
  constructor(container) {
    /**
     * @type {HTMLElement}
     */
    this.container = container;

    /**
     * @type {HTMLSelectElement}
     */
    this.select = container.querySelector('select');

    /**
     * @type {HTMLElement}
     */
    this.conditionalField = container.nextElementSibling;

    /**
     * @type {HTMLInputElement}
     */
    this.otherInput = this.conditionalField?.querySelector('input');

    /**
     * @type {string}
     */
    this.conditionalValue = this.container.dataset.conditionalValue;

    /**
     * @type {TomSelect}
     */
    this.tomSelect = this.select.tomselect;

    this.originalName = this.otherInput?.getAttribute('name');

    this.init();
  }

  /**
   * Инициализирует компонент.
   * Настраивает обработчики событий и первоначальное состояние.
   *
   * @returns {void}
   */
  init() {
    if (!this.tomSelect) {
      return;
    }

    // Слушаем события изменения TomSelect
    this.tomSelect.on('change', this.handleSelectChange.bind(this));
    this.toggleConditionalField();
  }

  /**
   * Обрабатывает изменение значения в селекте.
   *
   * @param {string} value - Новое значение селекта
   * @returns {void}
   */
  handleSelectChange(value) {
    this.toggleConditionalField();
  }

  /**
   * Переключает видимость дополнительного поля ввода.
   * Показывает поле если выбрано условное значение, скрывает в противном случае.
   *
   * @returns {void}
   */
  toggleConditionalField() {
    const currentValue = this.tomSelect.getValue();
    const isOtherSelected = currentValue === this.conditionalValue;

    const textAllParticipants = document.querySelector('.js-text-all-participants');
    const fileFormFields = document.querySelectorAll('.js-form-field-file');

    if (isOtherSelected) {
      this.conditionalField.classList.remove('d-none');
      this.otherInput?.setAttribute('required', 'true');
      if (this.originalName) {
        this.otherInput?.setAttribute('name', this.originalName);
      }

      if (textAllParticipants) {
        textAllParticipants.classList.remove('d-none');
      }

      if (fileFormFields) {
        fileFormFields.forEach((fileField) => {
          fileField.classList.add('is-multiple');
        });
      }
    } else {
      this.conditionalField.classList.add('d-none');
      this.otherInput?.removeAttribute('required');
      this.otherInput.value = '';
      this.otherInput?.removeAttribute('name');
      if (textAllParticipants) {
        textAllParticipants.classList.add('d-none');
      }

      if (fileFormFields) {
        fileFormFields.forEach((fileField) => {
          fileField.classList.remove('is-multiple');
            fileField.querySelectorAll(".js-file-block").forEach((field, index) => {
                if (index > 0) {
                    field.remove();
                }
            });
        });
      }
    }
  }

  /**
   * Возвращает текущее значение компонента.
   * Если выбрано условное значение - возвращает текст из дополнительного поля,
   * иначе - текст выбранной опции селекта.
   *
   * @returns {string} Текущее значение
   */
  getValue() {
    const currentValue = this.tomSelect.getValue();
    if (currentValue === this.conditionalValue) {
      return this.otherInput?.value || '';
    }
    return this.tomSelect.getItem(currentValue)[0]?.textContent || '';
  }
}
